(function() {
	'use strict';

	angular.module('exportWarehouseApp').config(stateConfig);

	stateConfig.$inject = [ '$stateProvider', '$urlRouterProvider',
			'GLOBAL_URL' ];

	function stateConfig($stateProvider, $urlRouterProvider, GLOBAL_URL) {
		$urlRouterProvider.otherwise("/stockOutUsedCancel");
		$stateProvider
				.state(
						'stockOutUsedCancel',
						{
							url : '/stockOutUsedCancel',
							data : {
								pageTitle : 'Xuất kho SD-HT-Hủy CN'
							},
							views : {
								'content@' : {
									templateUrl : GLOBAL_URL
											+ 'partial?uri=e-stock/exportwarehouse/exportreturn/layouts/stock-out-used-cancel',
									controller : 'StockOutUsedCancelController',
									controllerAs : 'vm'
								}
							}
						})
				.state(
						'createstockOutUsedCancel',
						{
							url : '/createstockOutUsedCancel/:typeProcess/:stockOutId',
							data : {
								pageTitle : 'Xuất kho SD-HT-Hủy CN'
							},
							params: { 
								stockOutId: {squash: true, value: null }
				            },
							views : {
								'content@' : {
									templateUrl : GLOBAL_URL
											+ 'partial?uri=e-stock/exportwarehouse/exportreturn/layouts/create-stock-out-used-cancel',
									controller : 'StockOutUsedCancelController',
									controllerAs : 'vm'
								}
							}
						});
	}
})();
